'use es6';

import { NOTE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Note = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: isUngated => isUngated('CRM:ILSFilters:ActivityFilters'),
  objectTypeId: NOTE_TYPE_ID,
  referenceObjectType: 'NOTE_PROPERTIES'
});
export default Note;